import { ApiVacancies } from "@/api/vacancy";
import { useTranslations } from "next-intl";
import { useLocalizedQuery } from "@/hooks/locale/useLocalizeQuery/useLocalizeQuery";

export const useVacanciesData = () => {
  const t = useTranslations("vacancy");

  const { data, isLoading } = useLocalizedQuery({
    queryKey: ["vacancies"],
    queryFn: async lang => ApiVacancies.getVacancies(lang),
  });

  const vacancies = [
    {
      title: t("vacancies.primary"),
      data: data?.primary ?? [],
    },
    {
      title: t("vacancies.other"),
      data: data?.others ?? [],
    },
  ];

  return { vacancies, isLoading };
};
